import {ComponentPropsWithoutRef, MouseEvent} from 'react';
import {createPortal} from 'react-dom';
import cn from 'classnames';

import DotLoading from '@/shared/components/DotLoading';

interface Props extends ComponentPropsWithoutRef<'button'> {
  isLoading: boolean;
  text: string;
}

const LoadingButton = ({isLoading, text, ...rest}: Props) => {
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    // 따닥방지
    if (isLoading) {
      e.preventDefault();
      return;
    }
    rest.onClick?.(e);
  };

  return (
    <>
      <button
        {...rest}
        type="button"
        className={cn(rest.className ? rest.className : 'btn btn_yellow', {
          loading: isLoading,
          disabled: rest.disabled
        })}
        onClick={handleClick}
      >
        {isLoading ? <DotLoading /> : text}
      </button>
      {isLoading && createPortal(<div className="touch_blocker" />, document.body)}
    </>
  );
};

export default LoadingButton;
